import axios from "axios";
import env from "@/env";
import { functions,getDocument } from "@/utils/firebase";
import { BookingRequest, BookingConfirmation } from "./types";
import { checkoutBooking } from "@/utils/stripe";

const createBookingCustomerFn = functions.httpsCallable(
  "createBookingCustomer"
);
const getBookingSummaryFn = functions.httpsCallable("getBookingSummary");

export const getBookingsAvailability = async (
  resourceId: string,
  serviceId: string
) => {
  const { data } = await getDocument(
    "availableBookings",
    `${resourceId}-${serviceId}`
  );
  return data ? data.bookings : data;
};

export const createBookingRequest = async (bookingRequest: BookingRequest): Promise<BookingConfirmation> => {
  const response = await createBookingCustomerFn({ booking: bookingRequest });
  const { bookingId, stripeCustomerId }: BookingConfirmation = response.data;

  if (stripeCustomerId) {
    await checkoutBooking({
      bookingId,
      stripeCustomerId,
      shopId: bookingRequest.storeId
    });
  }

  return  { bookingId, stripeCustomerId };
};

export const getBookingSummary = async (opts: { bookingId: string }) => {
  const response = await getBookingSummaryFn(opts);
  return response.data;
};
